<script setup lang="ts">
</script>

<template>
  <div class="request">
    <div class="request-catch">
      ＼ カンタン３分！<b>最短即日</b>見積もり ／
    </div>
    <div class="request-button">
      <a
        href="/step/step_init.html"
        class="button-step1"
        id="button-step1_ranking"
      >
        <span>無料</span>
        <div>見積もり依頼スタート！</div>
        <img
          src="~/assets/images/icon_cta_arrow.svg"
          alt=""
          width="24"
          height="24"
          aria-hidden="true"
          class="button-step1-icon"
        />
      </a>
      <div class="other-button">
        <a
          href="https://direct.nisshinfire.co.jp/oheya/?a1=852911&a2="
          class="button-lease"
          target="_blank"
          rel="noopener"
          id="button-lease_ranking"
        >
          <div>賃貸物件の方はこちら</div>
          <span>（外部サイト）</span>
        </a>
        <a
          href="/hojin/step/step_init.html"
          class="button-hojin"
          id="button-hojin_ranking"
        >
          <div>法人向け火災保険はこちら</div>
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.request {
  margin: 0 auto 10%;
  width: 345px;
  max-width: calc(100% - 30px);
}

.request-catch {
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $colorBlue;
  font-size: px(17);
  font-weight: 700;
  color: #fff;

  b {
    color: #fff800;
    font-weight: 700;
  }
}

.request-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 16px 24px;
  background-color: #fff;
  border: 3px solid $colorBlue;
  border-top: none;
  box-sizing: border-box;
}

.other-button {
  display: contents;
}

.button-step1 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  padding: 12px;
  border-radius: 6px;
  background-color: $colorBasicButton;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.16);
  text-decoration: none;
  box-sizing: border-box;

  > span {
    padding: 0 4px;
    flex: none;
    background-color: #fff800;
    color: red;
    font-size: px(15);
    font-weight: 700;
    line-height: 1.7;
  }

  > div {
    font-size: px(18);
    font-weight: 700;
    color: #fff;
  }
}

.button-step1-icon {
  flex: none;
  width: 24px;
  height: 24px;
}

.button-lease {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 288px;
  min-height: 40px;
  padding: 4px 32px 8px 16px;
  border-radius: 6px;
  background: #e6e6e6 url(~/assets/images/arrow_blue_sp.png) no-repeat right 8px center;
  background-size: 20px 20px;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.16);
  text-decoration: none;
  box-sizing: border-box;

  > div {
    font-size: px(15);
    font-weight: 700;
    color: $colorBlue;
  }

  span {
    font-size: px(10);
    color: #333;
  }
}

.button-hojin {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 288px;
  min-height: 40px;
  padding: 4px 32px 8px 16px;
  border-radius: 6px;
  background: #e6e6e6 url(~/assets/images/arrow_blue_sp.png) no-repeat right 8px center;
  background-size: 20px 20px;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.16);
  text-decoration: none;
  box-sizing: border-box;

  > div {
    font-size: px(15);
    font-weight: 700;
    color: $colorBlue;
  }
}

@include media(pc) {
  .request {
    margin: 0 0 80px;
    width: auto;
    max-width: none;
    border: 6px solid $colorBlue;
    border-radius: 4px;
  }

  .request-catch {
    height: auto;
    padding: 12px 8px;
    font-size: px(27.9);
  }

  .request-button {
    padding: 26px 0 22px;
    border: none;
  }

  .other-button {
    display: flex;
    margin: 0 auto;
    gap: 16px;
    width: 582px;
  }

  .button-step1 {
    margin: 0 auto 14px;
    width: 582px;
    padding: 21px;
    box-shadow: 0px 4px 0px 0px rgba(0, 0, 0, 0.16);

    &:hover {
      background-color: #f78c35;
    }

    > span {
      font-size: px(19.9);
    }

    > div {
      font-size: px(30);
    }
  }

  .button-lease {
    flex: 1;
    width: auto;
    min-height: 48px;
    box-shadow: 0px 4px 0px 0px rgba(0, 0, 0, 0.16);

    &:hover {
      background-color: #efefef;
    }

    > div {
      font-size: px(16);
    }

    span {
      font-size: px(12);
    }
  }

  .button-hojin {
    flex: 1;
    width: auto;
    min-height: 48px;
    box-shadow: 0px 4px 0px 0px rgba(0, 0, 0, 0.16);

    &:hover {
      background-color: #efefef;
    }

    > div {
      font-size: px(16);
    }
  }
}
</style>
